import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AlertOctagon, CheckCheck, Info, TriangleAlert } from "lucide-react";
import { toast } from "sonner";
import { Empty, NSelect, PageHeader, StatCard } from "@/components/common";
import { EventItem } from "@/components/EventItem";
import { useFleet } from "@/context/FleetContext";
import { api } from "@/lib/api";
import { EVENT_TYPES } from "@/lib/fleet";
import { cn } from "@/lib/utils";

const ALARM_TYPES = ["overspeed", "geofence_enter", "geofence_exit", "acc_on", "acc_off", "movement", "gps_offline", "power_cut", "low_battery", "engine"];

export default function Alarms() {
  const { vehicles, liveEvents } = useFleet();
  const [params] = useSearchParams();
  const [priority, setPriority] = useState("");
  const [type, setType] = useState("");
  const [vid, setVid] = useState(params.get("v") || "");
  const [status, setStatus] = useState("");
  const [data, setData] = useState({ items: [], counts: {} });

  const load = () => {
    const p = { limit: 300 };
    if (priority) p.priority = priority;
    if (type) p.type = type;
    if (vid) p.vehicle_id = vid;
    if (status) p.acknowledged = status === "done";
    return api.get("/events", { params: p }).then((r) => setData(r.data));
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [priority, type, vid, status, liveEvents.length]);

  const ack = async (id) => { await api.post(`/events/${id}/ack`); load(); };
  const ackAll = async () => { const { data: d } = await api.post("/events/ack-all"); toast.success(`${d.updated} alarm ditandai ditangani`); load(); };

  return (
    <div>
      <PageHeader eyebrow="Alarm Center" title="Pusat Alarm" subtitle="Overspeed, geofence, ACC, pergerakan, GPS offline, power & baterai — dengan prioritas INFO, WARNING, CRITICAL."
        actions={<button onClick={ackAll} className="flex items-center gap-2 rounded-full border border-border px-4 py-2.5 text-sm font-bold hover:border-primary" data-testid="alarm-ack-all"><CheckCheck className="h-4 w-4" /> Tangani semua</button>} />
      <div className="mb-5 grid grid-cols-3 gap-3">
        <StatCard label="Critical" value={data.counts.CRITICAL ?? 0} icon={AlertOctagon} tone="red" onClick={() => setPriority(priority === "CRITICAL" ? "" : "CRITICAL")} active={priority === "CRITICAL"} testId="alarm-count-critical" />
        <StatCard label="Warning" value={data.counts.WARNING ?? 0} icon={TriangleAlert} tone="amber" onClick={() => setPriority(priority === "WARNING" ? "" : "WARNING")} active={priority === "WARNING"} testId="alarm-count-warning" />
        <StatCard label="Info" value={data.counts.INFO ?? 0} icon={Info} tone="blue" onClick={() => setPriority(priority === "INFO" ? "" : "INFO")} active={priority === "INFO"} testId="alarm-count-info" />
      </div>
      <div className="gt-card mb-4 grid gap-3 p-3 sm:grid-cols-4">
        <NSelect value={priority} onChange={setPriority} testId="alarm-filter-priority"><option value="">Semua prioritas</option><option>CRITICAL</option><option>WARNING</option><option>INFO</option></NSelect>
        <NSelect value={type} onChange={setType} testId="alarm-filter-type"><option value="">Semua jenis</option>{ALARM_TYPES.map((t) => <option key={t} value={t}>{EVENT_TYPES[t].label}</option>)}</NSelect>
        <NSelect value={vid} onChange={setVid} testId="alarm-filter-vehicle"><option value="">Semua kendaraan</option>{vehicles.map((v) => <option key={v.id} value={v.id}>{v.name} · {v.plate}</option>)}</NSelect>
        <div className="flex rounded-xl border border-border p-1">
          {[["", "Semua"], ["open", "Aktif"], ["done", "Ditangani"]].map(([k, l]) => (
            <button key={k} onClick={() => setStatus(k)} className={cn("flex-1 rounded-lg py-1.5 text-xs font-semibold", status === k ? "bg-foreground text-background" : "text-muted-foreground")} data-testid={`alarm-status-${k || "all"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="gt-card p-2" data-testid="alarm-list">
        {data.items.map((e) => <EventItem key={e.id} e={e} onAck={ack} />)}
        {!data.items.length && <Empty title="Tidak ada alarm" text="Tidak ada alarm sesuai filter." />}
      </div>
    </div>
  );
}
